module.exports = __webpack_public_path__ + "img/descImg3.2ab55811.png";